import { ChartsList } from '../../types';

const monthCategories = [
  '2021-08-01',
  '2021-09-01',
  '2021-10-01',
  '2021-11-01',
  '2021-12-01',
  '2022-01-01',
  '2022-02-01',
  '2022-03-01',
  '2022-04-01',
  '2022-05-01',
  '2022-06-01',
  '2022-07-01',
  '2022-08-01',
  '2022-09-01',
  '2022-10-01',
  '2022-11-01',
  '2022-12-01',
  '2023-01-01',
  '2023-02-01',
  '2023-03-01',
  '2023-04-01',
  '2023-05-01',
  '2023-06-01',
  '2023-07-01',
  '2023-08-01',
  '2023-09-01',
  '2023-10-01',
  '2023-11-01',
  '2023-12-01',
  '2024-01-01',
  '2024-02-01',
  '2024-03-01',
  '2024-04-01',
  '2024-05-01',
  '2024-06-01',
  '2024-07-01',
  '2024-08-01',
  '2024-09-01',
  '2024-10-01',
  '2024-11-01',
  '2024-12-01',
];

const yearCategories = ['2021', '2022', '2023', '2024'];

export const fiagroPrimaryCharts: ChartsList = {
  emissionsFIDC: {
    chartType: 'column',
    numeric: true,
    stacked: false,
    data: [
      {
        name: 'Montante emitido',
        data: [72522549.27, 1337614222.87, 4572158814.51, 2869729266.24],
      },
    ],
    categories: yearCategories,
  },
  emissionsByTypeOfCondominium: {
    chartType: 'column',
    data: [
      {
        name: 'Condominio Fechado',
        data: [100, 100, 98.67, 91.32],
      },
      {
        name: 'Condomínio Aberto',
        data: [0, 0, 1.33, 8.68],
      },
    ],
    categories: yearCategories,
  },
  emissionsFII: {
    chartType: 'column',
    numeric: true,
    stacked: false,
    data: [
      {
        name: 'Montante emitido',
        data: [2179226533.7, 6673152928.94, 6791878663.67, 1810649092.67],
      },
    ],
    categories: yearCategories,
  },
  emissionsFIIFIDC: {
    chartType: 'column',
    numeric: true,
    stacked: false,
    data: [
      {
        name: 'Montante emitido',
        data: [
          20000000, 16898614.83, 2251749082.97, 8010767151.82, 11364037478.18,
          4680378358.9,
        ],
      },
    ],
    categories: ['2019', '2020', ...yearCategories],
  },
  emissionsByTypeOfImmobile: {
    chartType: 'column',
    data: [
      {
        name: 'Fazenda',
        data: [100, 63.29, 76.36, 79.05],
      },
      {
        name: 'Especial',
        data: [0, 36.71, 23.64, 11.36],
      },
      {
        name: 'Indeterminado',
        data: [0, 0, 0, 9.59],
      },
    ],
    categories: yearCategories,
  },
};

export const fiagroSecondaryCharts: ChartsList = {
  amountNegotiatedFIDC: {
    chartType: 'line-column',
    data: [
      {
        name: 'Montante negociado',
        type: 'column',
        data: [217771655.1, 542021472.31, 591280013.44],
      },
      {
        name: 'Número de negociações',
        type: 'line',
        data: [120596, 253694, 370824],
      },
    ],
    categories: ['2022', '2023', '2024'],
  },
  amountNegotiatedFII: {
    chartType: 'line-column',
    data: [
      {
        name: 'Montante negociado',
        type: 'column',
        data: [75192593.5, 2706319299.26, 7489407196.25, 10397795961.62],
      },
      {
        name: 'Número de negociações',
        type: 'line',
        data: [61738, 9140317, 16359117, 17757132],
      },
    ],
    categories: yearCategories,
  },
  amountNegotiatedEnvironment: {
    chartType: 'line-column',
    data: [
      {
        name: 'Montante negociado',
        type: 'column',
        data: [422802049.08, 168477964.36],
      },
      {
        name: 'Número de negociações',
        type: 'line',
        data: [248028, 368344],
      },
    ],
    categories: ['Cetip', 'BM&FBovespa'],
  },
  amountNegotiatedEnvironmentNumber: {
    chartType: 'line-column',
    data: [
      {
        name: 'Montante negociado',
        type: 'column',
        data: [422802049.08, 168477964.36],
      },
      {
        name: 'Número de negociações',
        type: 'line',
        data: [28, 298],
      },
    ],
    categories: ['Cetip', 'BM&FBovespa'],
  },
};

export const fiagroStockCharts: ChartsList = {
  liquidFIDC: {
    chartType: 'line-column',
    data: [
      {
        name: 'Patrimônio Líquido',
        type: 'column',
        data: [2413705947.92, 11472182088.86, 20865658529.5, 25968748795.19],
      },
      {
        name: 'Núm. de FIAGROs-FII, FIDC e FIP',
        type: 'line',
        data: [17, 47, 86, 121],
      },
    ],
    categories: ['dez/2021', 'dez/2022', 'dez/2023', 'dez/2024'],
  },
  creditoryFIDC: {
    chartType: 'column',
    numeric: true,
    stacked: false,
    data: [
      {
        name: 'Direitos creditórios',
        data: [1586212768.49, 3413330911.65, 5604540047.13],
      },
    ],
    categories: ['dez/2022', 'dez/2023', 'dez/2024'],
  },
  liquidFII: {
    chartType: 'line-column',
    data: [
      {
        name: 'Patrimômio Líquido',
        type: 'column',
        data: [
          559056881.31, 559780066.89, 990413165.53, 1440927898.69,
          2189748388.48, 2421260701.63, 3336466347.05, 3433260410.24,
          3661741595.72, 4051405171, 4679360963.59, 5187157086.53,
          5694603641.65, 6133275045.93, 7236455267.41, 7917176089.67,
          9257510982.38, 10139088910.22, 10247041797.6, 10761404323.46,
          11692964498.34, 12224717684.73, 12696159319.6, 13370635610.36,
          14057093182.43, 14728998691.84, 15874999777.97, 15930386153.81,
          16124130839.03,
        ],
      },
      {
        name: 'Núm. de FIAGROs-FII',
        type: 'line',
        data: [
          3, 3, 5, 9, 13, 15, 17, 18, 23, 25, 27, 28, 28, 28, 28, 28, 32, 33,
          34, 36, 37, 39, 40, 40, 41, 43, 44, 45, 45,
        ],
      },
    ],
    categories: monthCategories,
  },
  liquidByFinalityFII: {
    chartType: 'column',
    data: [
      {
        name: 'Gestão de Ativos Financeiros',
        data: [
          39.888725685203575, 39.96755161058, 36.80976715761934,
          50.99992043724734, 67.20207480830578, 66.74726864405885,
          75.88003976957421, 76.50496207237563, 76.87450553748056,
          74.35258032867073, 74.13326780391432, 71.77253566308529,
          71.994979504352, 73.97578302494055, 72.95565555426353,
          75.10418536406233, 72.97496315184705, 75.46340033193357,
          74.80880895250579, 72.53175111146089, 72.25512407858106,
          73.47636330792196, 73.11151921077537, 73.78830406032105,
          74.05119614224935, 71.97400039340813, 67.6448450956337,
          67.49721036679551, 67.64199168540192, 70.15384615384615,
          70.15384615384615, 70.15384615384615, 70.15384615384615,
          70.15384615384615, 70.15384615384615, 70.15384615384615,
          70.15384615384615, 70.15384615384615, 70.15384615384615,
          70.15384615384615, 70.15384615384615,
        ],
      },
      {
        name: 'Diversas',
        data: [
          0.0, 0.0, 29.26064106235084, 25.679994733005586, 16.922699648484503,
          18.895648207233567, 13.70123296955135, 13.370194368329653,
          12.772325563787886, 12.035998034628298, 13.70065713669899,
          16.917413387937984, 17.653072051713934, 16.401174014811676,
          18.8738608742735, 17.34012160507288, 19.214222604062215,
          17.517754382740303, 17.20002809330592, 19.90071309216858,
          20.76534051193523, 19.82996392945774, 19.9488174866397,
          18.942713324395253, 18.03399887857735, 18.37562516866439,
          22.999477676634584, 22.837146848696474, 22.52234863834972,
          24.615384615384613, 24.615384615384613, 24.615384615384613,
          24.615384615384613, 24.615384615384613, 24.615384615384613,
          24.615384615384613, 24.615384615384613, 24.615384615384613,
          24.615384615384613, 24.615384615384613, 24.615384615384613,
        ],
      },
      {
        name: 'Renda',
        data: [
          60.111274314796425, 60.032448389420004, 33.929591780029824,
          23.320084829747078, 15.875225543209712, 14.357083148707595,
          10.418727260874446, 10.124843559294716, 10.353168898731568,
          13.611421636700985, 12.166075059386698, 11.310050948976732,
          10.351948443934072, 9.62304296024777, 8.17048357146296,
          7.55569303086478, 7.810814244090722, 7.01884528532612,
          7.99116295418828, 7.567535796370517, 6.979535409483713,
          6.693672762620309, 6.939663302584949, 7.268982615283698,
          7.914804979173298, 9.650374437927477, 9.355677227731714,
          9.665642784508014, 9.83565967624836, 5.230769230769231,
          5.230769230769231, 5.230769230769231, 5.230769230769231,
          5.230769230769231, 5.230769230769231, 5.230769230769231,
          5.230769230769231, 5.230769230769231, 5.230769230769231,
          5.230769230769231, 5.230769230769231,
        ],
      },
    ],
    categories: monthCategories,
  },
  liquidByManagementTypeFii: {
    chartType: 'column',
    data: [
      {
        name: 'Gestão Ativa',
        data: [95.94, 97.75, 97.95],
      },
      {
        name: 'Gestão Passiva',
        data: [4.06, 2.25, 2.05],
      },
    ],
    categories: ['2022', '2023', '2024'],
  },
};
